<template>
    <div class="login-header-component" ref="loginHeader">
        <div class="login-header-component-wrapper">
            <div class="header-container">
                <h1>{{ !selectCountryPage ? $t('welcome') : $t('experience_fit20') }}</h1>
            </div>
            <div class="title-container">
                <p>{{ !selectCountryPage ? $t('at_your_fit20') : $t('in_your_neighbourhood') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginHeader',
    data() {
        return {
            selectCountryPage: this.$store.selectCountryPage,
        };
    },
    // computed: {
    //     currentLanguage() {
    //         console.log("currentLanguage function from computed...");
    //         console.log("this.$store.selectedAppLanguage: " + this.$store.selectedAppLanguage);
    //         return this.$store.selectedAppLanguage;
    //     },
    // },
    // watch: {
    //     currentLanguage() {
    //         console.log("currentLanguage function from watch...");
    //         console.log("this.$store.selectedAppLanguage: " + this.$store.selectedAppLanguage);
    //         this.$store.changeAppLanguage(this.$store.selectedAppLanguage);
    //     },
    // },
}
</script>

<style>
.login-header-component {
    height: 40vw;
    min-height: 152px;
    max-height: 200px;
    border-bottom: 2px solid #E6E6E6;
    background-image: url('../../assets/imgs/fit20_dna_header.png');
    background-size: cover;
    background-position: 30px 0;
    box-shadow: 0 0 5px 0 #E6E6E6;
}

.login-header-component .login-header-component-wrapper {
    height: 100%;
    padding: 10px 0 0 40px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

[dir="rtl"] .login-header-component .login-header-component-wrapper {
    padding: 10px 40px 0 0 ;
}

.login-header-component h1 {
    font-family: 'VAG Rounded Std', sans-serif;
    line-height: 50px;
    font-size: 70px;
    color: #92d400;
    letter-spacing: -1px;
}

.login-header-component .title-container p {
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 46px;
    color: #616365;
    font-weight: 500;
    letter-spacing: -1px;
    padding-top: 15px;
}

@media (max-width: 576px) {
    .login-header-component .login-header-component-wrapper {
        padding: 5px 0 0 7.5vw;
    }

    .login-header-component h1 {
        font-size: calc(15px + 10vw);
    }

    .login-header-component .title-container p {
        font-size: calc(9px + 8vw);
    }
}
</style>